import {useFetchHousing, useFetchHousingLocation} from 'hooks';
import {AUTH_INIT_MODELS} from '@chekin/core';
import {useChekinSDK} from 'context/ChekinSDK';

type Options = {
  housingId?: string;
};

function useHousing({housingId: housingIdOverride}: Options = {}) {
  const {objectId, modelName} = useChekinSDK();
  const housingId = housingIdOverride ?? objectId;

  const {
    data: housing,
    isSuccess: isSuccessLoadedHousing,
    isLoading: isHousingLoading,
    isFetching: isHousingFetching,
  } = useFetchHousing(housingId, {
    refetchOnWindowFocus: false,
    enabled: housingIdOverride
      ? Boolean(housingIdOverride)
      : modelName === AUTH_INIT_MODELS.housing,
  });

  const {
    data: locationCountry,
    isSuccess: isSuccessLoadedHousingLocation,
    isLoading: isLocationLoading,
  } = useFetchHousingLocation({
    housingLocation: housing?.location,
  });

  return {
    housing,
    housingLocation: locationCountry,
    housingCountry: locationCountry?.country?.code,
    isLoaded: isSuccessLoadedHousing && isSuccessLoadedHousingLocation,
    isLoading:
      isHousingLoading || (isHousingFetching && !housing?.id) || isLocationLoading,
  };
}

export {useHousing};
